import { createSelector } from 'reselect';

const projectCreateData = state => state.projectCreatePopupData;

export const isProjectCreatePopupOpenedSelector = createSelector(
    projectCreateData,
    (popupData) => popupData.isOpened,
);
